import ReactDOM from "react-dom/client";

import router from "./routes/router";

import { RouterProvider } from "react-router-dom";

// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/css/bootstrap.rtl.min.css";
import "./fonts.css";
import "./index.css";
import 'react-tooltip/dist/react-tooltip.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { ThemeProvider } from "next-themes";
import { Toaster } from "react-hot-toast";
import { AmcProvider } from "./store/AmcContext";
import AuthProvider from "./store/AuthContext";
import { LanguageProvider } from "./store/LanguageProvider";
// import './config/i18n';

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <ThemeProvider
    disableTransitionOnChange={true}
    defaultTheme='dark'
    attribute="data-theme"
  >
    <Toaster
      position='top-right'
      reverseOrder={false}
      gutter={8}
      toastOptions={{
        duration: 3000,
        removeDelay: 500,
        style: {
          margin: "0",
        },
      }}
    />
    <AuthProvider>
      <AmcProvider>
        <LanguageProvider>
          <RouterProvider router={router} />
        </LanguageProvider>
      </AmcProvider>
    </AuthProvider>
  </ThemeProvider>,
  // </React.StrictMode>
);
